// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSocialMediaStrava_root__3rps1"};